import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

export type UseBulkUpdateComponentsRequestBody = {
  quoteId: number;
  componentIds: Array<number>;
  estimatorId?: number;
  updateQuoteEstimator?: boolean;
};

export type UseBulkUpdateComponentsResponseBody = unknown;

export const useBulkUpdateComponents: MutationFunction<
  UseBulkUpdateComponentsResponseBody,
  UseBulkUpdateComponentsRequestBody
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(
    ({ quoteId, ...body }) =>
      request(`/quotes/${quoteId}/components/bulk_update`, {
        query,
        init: {
          method: 'PATCH',
          body,
        },
      }),
    queryOptions,
  );
};
